import React, { useState } from "react";
import {
  Autocomplete,
  TextField,
  Tooltip,
  Popper,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { styled } from "@mui/material/styles";
import { OptionType } from "../lead-assignment-props";
import "../../../../common/components/autocomplete-component/autocomplete.scss";

const CustomPopper = styled(Popper)({
  zIndex: '5 !important',
  '& .MuiAutocomplete-listbox': {
    maxHeight: '250px',
    overflowY: 'auto',
    padding: 0,
    margin: 0,
  },
  '& .MuiPaper-root': {
    padding: 0,
    overflow: 'hidden',
  }
});
interface SingleSelectAutocompleteProps {
  options: OptionType[];
  selectedValue: OptionType | null;
  onChange: (val: OptionType | null) => void;
  placeholder?: string;
  noOptionsFoundText: string;
  disable?: boolean;
  fieldName?: string
  inputRef?: any;
}

const SingleSelectAutocomplete: React.FC<SingleSelectAutocompleteProps> = ({
    options,
    selectedValue,
    onChange,
    placeholder = "Select",
    noOptionsFoundText,
    disable = false,
    fieldName,
    inputRef,
    
  }) => {
   const [inputValue, setInputValue] = useState("");
    const filterOptions = React.useCallback(
      (opts: OptionType[]) => {
        const search = inputValue.trim().toLowerCase();
        if (!search) return opts.slice(0, 100);
        return opts.filter((opt) => opt.label.toLowerCase().includes(search)).slice(0, 100);
      },
      [inputValue]
    );
  
    React.useEffect(() => {
      // Whenever selectedValue changes, update the inputValue.
      if (selectedValue) {
        setInputValue(selectedValue.label);
      }
    }, [selectedValue]);
  
    return (
      <div className="autocomplete-multi-select-input-component">
        <Autocomplete
          disablePortal
          popupIcon={<KeyboardArrowDownIcon />}
          options={options}
          inputValue={inputValue}
          value={selectedValue}
          componentsProps={{
            paper: {
              sx: {
                padding: '0px !important',
              }
            }
          }}
          onChange={(_event, newValue: OptionType | null) => {
            onChange(newValue); // Update the selected value
            if (newValue) {
              setInputValue(newValue.label); // Sync inputValue with selected value
            } else {
              setInputValue(""); // Reset inputValue if no selection
            }
          }}
          getOptionLabel={(option) => option.label}
          filterOptions={filterOptions}
          noOptionsText={noOptionsFoundText}
          onInputChange={(_, newInputValue, reason) => {
            if (reason === "clear") {
              setInputValue(newInputValue); // Reset the inputValue when the input is cleared
            } else if (reason === "input") {
              setInputValue(newInputValue); // Update inputValue as the user types
            }
          }}
          PopperComponent={CustomPopper}
          renderInput={(params) => {
              return <TextField
                {...params}
                placeholder={selectedValue ? "" : placeholder}
                inputRef={inputRef}
                InputProps={{
                  ...params.InputProps,
                  style: {
                    display: "flex",
                    alignItems: "center",
                  },
                  startAdornment: selectedValue && !inputValue && (
                    <Tooltip title={selectedValue.label} placement="top">
                      <div
                        style={{
                          maxWidth: "calc(100% - 30px)",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: "#000",
                          fontSize: "14px",
                        }}
                      >
                        {selectedValue.label.length > 30
                          ? selectedValue.label.slice(0, 30) + "..."
                          : selectedValue.label}
                      </div>
                    </Tooltip>
                  ),
                }}
              />
          }}
          disabled={disable}
        />
      </div>
    );
  };
  

export default SingleSelectAutocomplete;
